import type { LiksMembersPanelMember } from '../../../components/liks/LiksMembersPanel/LiksMembersPanel';
import type {
  KnowledgeBaseGroupAssignment,
  KnowledgeBaseMembership,
  KnowledgeMemberRole,
} from '../../../types/knowledge';
import {
  KNOWLEDGE_MEMBER_ROLES,
  maxKnowledgeMemberRole,
} from './knowledgeDatabaseMembersPanelHelpers';

type GroupMemberUser = {
  id: string;
};

export function buildGroupOnlyKnowledgeMembers(options: {
  assignments: KnowledgeBaseGroupAssignment[];
  groupMemberLists: Array<GroupMemberUser[] | undefined>;
  members: KnowledgeBaseMembership[];
}): LiksMembersPanelMember<KnowledgeMemberRole>[] {
  const { assignments, groupMemberLists, members } = options;
  const roleByUserId = new Map<string, KnowledgeMemberRole>();

  for (let index = 0; index < assignments.length; index += 1) {
    const assignment = assignments[index];
    const memberUsers = groupMemberLists[index] ?? [];
    const role = assignment?.role;
    if (!role || !KNOWLEDGE_MEMBER_ROLES.includes(role)) {
      continue;
    }
    for (const member of memberUsers) {
      const memberUserId = member.id;
      const existing = roleByUserId.get(memberUserId);
      roleByUserId.set(
        memberUserId,
        existing ? maxKnowledgeMemberRole(existing, role) : role,
      );
    }
  }

  const directUserIds = new Set(
    members
      .map((member) => member.userId)
      .filter((id): id is string => typeof id === 'string' && id.length > 0),
  );

  const virtual: LiksMembersPanelMember<KnowledgeMemberRole>[] = [];
  for (const [userId, role] of roleByUserId) {
    if (directUserIds.has(userId)) {
      continue;
    }
    virtual.push({
      id: `group-member:${userId}`,
      userId,
      role,
    });
  }
  return virtual;
}
